import { Route, Routes } from 'react-router-dom';
import Analytics from './components/Analytics';
import Footer from './components/Footer';
import Header from './components/Header';
import WhatsAppButton from './components/WhatsAppButton';
import Contact from './pages/Contact';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import ProgramPage from './pages/ProgramPage';

export default function App() {
  return (
    <>
      <Analytics />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/programas/:slug" element={<ProgramPage />} />
        <Route path="/contacto" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      <WhatsAppButton />
    </>
  );
}
